<template>
  <div class="page flex-col" :class="`lang-${currentLang}`">
    <div class="box_1 flex-col">
      <video class="background-video" autoplay muted loop>
        <source src="./assets/video/banner.mp4" type="video/mp4">
        您的浏览器不支持视频播放。
      </video>
      
      <!-- ARK Coach 标题 -->
      <div class="hero-brand-title">ARK Coach</div>
      
      <!-- 下一代智能陪练系统 -->
      <h1 class="hero-main-title">下一代智能陪练系统</h1>
      
      <!-- 描述段落 -->
      <div class="hero-description">
        <p class="hero-desc-line">
          融合<span class="text-highlight-blue">最新大语言模型</span>与<span class="text-highlight-blue">情感化数字人技术</span>，集成<span class="text-highlight-blue">10大核心模块</span>，为企业打造沉浸式、个性化、数据驱动的员工技能训练平台。
        </p>
        <p class="hero-desc-line">
          支持实时面部识别防作弊、多维度智能评分、个性化数字人角色库、AI自动搭课等前沿功能。现在预约演示，即可获得专属企业定制方案与<span class="trial-badge">7天免费试用</span>。
        </p>
      </div>
      
      <!-- 功能标签 -->
      <div class="hero-feature-tags">
        <span class="feature-tag">300% 提效</span>
        <span class="feature-tag">50% 降本</span>
        <span class="feature-tag">防作弊</span>
        <span class="feature-tag">多维度评分</span>
        <span class="feature-tag">数字人角色库</span>
        <span class="feature-tag">AI自动搭课</span>
      </div>
      
      <!-- 按钮组 -->
      <div class="hero-buttons">
        <button class="hero-btn hero-btn-primary" @click="handleLogin">立即免费体验</button>
        <button class="hero-btn hero-btn-secondary">观看产品演示</button>
      </div>
      <div class="box_4 flex-row">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng16ee377bf3900b894ac1a754b3ddf9a2644c0d6562e303bb552757bf414514b1.png"
        />
        <span class="text_6" @click="scrollToSection('core-abilities')">{{ $t('product') }}</span>
        <span class="text_7" @click="scrollToSection('application-scenarios')">{{ $t('scene') }}</span>
        <span class="text_8" @click="scrollToSection('trusted-platform')">{{ $t('case') }}</span>
        <span class="text_9" @click="scrollToSection('contact-us')">{{ $t('contact') }}</span>
        <span class="text_98">{{ $t('hotline') }}400-831-9111</span>
        <!-- 国际化下拉框 -->
        <div class="lang-dropdown">
          <div class="lang-trigger" @click="toggleLangDropdown">
            <img class="lang-icon" src="./assets/img/language.svg" alt="语言选择" />
          </div>
          <div class="lang-options" v-show="showLangDropdown">
            <div class="lang-option" @click="selectLang('zh-CN')" :class="{ active: currentLang === 'zh-CN' }">
              <span class="flag">🇨🇳</span>
              <span class="text">简体中文</span>
              <span class="check" v-if="currentLang === 'zh-CN'">✓</span>
            </div>
            <div class="lang-option" @click="selectLang('zh-TW')" :class="{ active: currentLang === 'zh-TW' }">
              <span class="flag">🇭🇰</span>
              <span class="text">繁體中文</span>
              <span class="check" v-if="currentLang === 'zh-TW'">✓</span>
            </div>
            <div class="lang-option" @click="selectLang('en')" :class="{ active: currentLang === 'en' }">
              <span class="flag">🇺🇸</span>
              <span class="text">English</span>
              <span class="check" v-if="currentLang === 'en'">✓</span>
            </div>
          </div>
        </div>
        <div class="text-wrapper_4 flex-col" role="button" tabindex="0" @click="handleLogin" @keydown.enter.prevent="handleLogin" @keydown.space.prevent="handleLogin"><span class="text_10">{{ $t('login') }}</span></div>
        <div class="text-wrapper_5 flex-col"><span class="text_11">{{ $t('bookDemo') }}</span></div>
      </div>
    </div>
    <div class="box_74 flex-col">
      <!-- 限时优惠区域 -->
      <div class="promo-section">
        <h2 class="promo-title">限时优惠</h2>
        <p class="promo-subtitle">选择最适合您的方案</p>
        <div class="promo-cards">
          <!-- 免费试用卡片 -->
          <div class="promo-card promo-card-free">
            <div class="card-badge card-badge-limited">
              <span>限时</span>
            </div>
            <div class="card-header">
              <div class="card-icon-wrapper">
                <img
                  class="card-icon"
                  referrerpolicy="no-referrer"
                  src="./assets/img/SketchPngf29e0f57d637c21852ec931ef2e4b08f107ebff9b0664f1001ea7b5b069e618b.png"
                />
              </div>
            </div>
            <div class="card-info">
              <span class="card-title">免费试用</span>
              <span class="card-subtitle">7天完整功能体验，无任何限制</span>
            </div>
            <div class="card-price">
              <span class="price-current">¥0</span>
              <span class="price-original">原价 ¥299</span>
            </div>
          </div>

          <!-- 企业定制卡片 -->
          <div class="promo-card promo-card-custom">
            <div class="card-badge card-badge-exclusive">
              <span>专属</span>
            </div>
            <div class="card-header">
              <div class="card-icon-wrapper">
                <img
                  class="card-icon"
                  referrerpolicy="no-referrer"
                  src="./assets/img/SketchPngc45b089db468cbb2e0e7ec0047f274ab55bb78a6666601d6c98ac8123ecd153a.png"
                />
              </div>
            </div>
            <div class="card-info">
              <span class="card-title">企业定制</span>
              <span class="card-subtitle">专属方案设计，一对一服务</span>
            </div>
            <div class="card-price">
              <span class="price-current">¥0</span>
              <span class="price-original">原价 ¥5000</span>
            </div>
          </div>

          <!-- 智能部署卡片 -->
          <div class="promo-card promo-card-ai">
            <div class="card-badge card-badge-ai">
              <span>AI</span>
            </div>
            <div class="card-header">
              <div class="card-icon-wrapper">
                <img
                  class="card-icon"
                  referrerpolicy="no-referrer"
                  src="./assets/img/SketchPng58a5762b882328cc823981c3506014d425a9158b3261e6d2e6c9a330aa6bcc94.png"
                />
              </div>
            </div>
            <div class="card-info">
              <span class="card-title">智能部署</span>
              <span class="card-subtitle">AI 自动搭课，零等待部署</span>
            </div>
            <div class="card-benefit">
              <span class="benefit-label">立享</span>
              <span class="benefit-value">节省80%时间</span>
            </div>
          </div>
        </div>
      </div>
      <div id="core-abilities" class="text-group_69 flex-col justify-between">
        <span class="text_13">{{ $t('sixCoreAbilities') }}</span>
        <span class="text_99">{{ $t('reconstructProfessionalPath') }}</span>
      </div>
      <div class="box_76 flex-row justify-between">
        <div class="box_77 flex-col justify-between">
          <div class="text-group_70 flex-row">
            <span class="paragraph_3">
              {{ $t('ultraRealisticAiTraining') }}
            </span>
            <span class="text_14">
              {{ $t('arkCoachDesc2') }}
            </span>
          </div>
          <div class="block_1 flex-row" @click="handleLogin">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng61f028505d78efc82f11e7f2c0ffad4b55b6f1d304dc40eec8d1ca0bdcbe7b4c.png"
            />
            <span class="text_15">{{ $t('experienceNow') }}</span>
          </div>
        </div>
        <div class="group_4 flex-col">
          <div class="section_1 flex-col">
            <div class="image-wrapper_1 flex-col">
              <img
                class="image_4"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng36ca2ffa44ea7e122bfcd882fab4c31e93ceedc5f841741fd17bec938ce6c5b3.png"
              />
            </div>

          </div>
        </div>
      </div>
      <div class="box_78 flex-row justify-between">
        <div class="group_6 flex-col">
          <div class="box_11 flex-col">
            <div class="image-wrapper_2 flex-col">
              <img
                class="image_6"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng36ca2ffa44ea7e122bfcd882fab4c31e93ceedc5f841741fd17bec938ce6c5b3.png"
              />
            </div>

          </div>
        </div>
        <div class="box_79 flex-col justify-between">
          <div class="text-group_71 flex-col justify-between">
            <span class="text_16">{{ $t('dynamicCustomerPortrait') }}</span>
            <span class="text_17">
              {{ $t('dynamicCustomerPortraitDesc') }}
            </span>
          </div>
          <div class="block_3 flex-row" @click="handleLogin">
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng7e6c73b9e78fdeb3c68bcf92963e26c1bf6d8882feb1cd1c18e110422a3f764c.png"
            />
            <span class="text_18">{{ $t('experienceNow') }}</span>
          </div>
        </div>
      </div>
      <div class="box_80 flex-row justify-between">
        <div class="box_81 flex-col justify-between">
          <div class="text-group_72 flex-col justify-between">
            <span class="text_19">{{ $t('realTimeEmotionInsight') }}</span>
            <span class="text_20">
              {{ $t('realTimeEmotionInsightDesc') }}
            </span>
          </div>
          <div class="section_3 flex-row" @click="handleLogin">
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng61f028505d78efc82f11e7f2c0ffad4b55b6f1d304dc40eec8d1ca0bdcbe7b4c.png"
            />
            <span class="text_21">{{ $t('experienceNow') }}</span>
          </div>
        </div>
        <div class="section_4 flex-col">
          <div class="group_9 flex-col">
            <div class="image-wrapper_4 flex-col">
              <img
                class="image_10"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng36ca2ffa44ea7e122bfcd882fab4c31e93ceedc5f841741fd17bec938ce6c5b3.png"
              />
            </div>

          </div>
        </div>
      </div>
      <div class="box_82 flex-row justify-between">
        <div class="box_12 flex-col">
          <div class="group_11 flex-col">


          </div>
        </div>
        <div class="box_83 flex-col justify-between">
          <div class="text-group_73 flex-col justify-between">
            <span class="paragraph_4">
              {{ $t('instantIntelligentScoring') }}
              <br />
            </span>
            <span class="paragraph_5">
              {{ $t('instantIntelligentScoringDesc') }}
            </span>
          </div>
          <div class="box_27 flex-row" @click="handleLogin">
            <img
              class="image_55"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng7e6c73b9e78fdeb3c68bcf92963e26c1bf6d8882feb1cd1c18e110422a3f764c.png"
            />
            <span class="text_106">{{ $t('experienceNow') }}</span>
          </div>
        </div>
      </div>
      <div class="box_84 flex-row justify-between">
        <div class="block_21 flex-col justify-between">
          <div class="text-group_74 flex-col justify-between">
            <span class="text_29">{{ $t('scientificCapabilityModel') }}</span>
            <span class="text_30">
              {{ $t('scientificCapabilityModelDesc') }}
            </span>
          </div>
          <div class="group_14 flex-row" @click="handleLogin">
            <img
              class="image_14"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng61f028505d78efc82f11e7f2c0ffad4b55b6f1d304dc40eec8d1ca0bdcbe7b4c.png"
            />
            <span class="text_31">{{ $t('experienceNow') }}</span>
          </div>
        </div>
        <div class="group_15 flex-col">
          <div class="box_15 flex-col">
            <div class="image-wrapper_7 flex-col">
              <img
                class="image_15"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng36ca2ffa44ea7e122bfcd882fab4c31e93ceedc5f841741fd17bec938ce6c5b3.png"
              />
            </div>

          </div>
        </div>
      </div>
      <div class="box_85 flex-row justify-between">
        <div class="group_17 flex-col">
          <div class="box_16 flex-col">

          </div>
        </div>
        <div class="box_86 flex-col justify-between">
          <span class="text_32">{{ $t('immersiveMultimodalInteraction') }}</span>
          <span class="text_33">
            {{ $t('arkCoachDesc3') }}
          </span>
          <div class="section_28 flex-row" @click="handleLogin">
            <img
              class="image_56"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng7e6c73b9e78fdeb3c68bcf92963e26c1bf6d8882feb1cd1c18e110422a3f764c.png"
            />
            <span class="text_107">{{ $t('experienceNow') }}</span>
          </div>
        </div>
      </div>
      <div class="group_19 flex-col">
        <span class="text_35">{{ $t('fiveStepsToEnhanceDialogueAbility') }}</span>
        <div class="group_68 flex-row">
          <div class="text-wrapper_13 flex-col">
            <img
              class="label_42"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng04edbc8cbf7886c85da1785df69f9806e859ccdb2333c4b95a1e4362b6e4748f.png"
            />
          </div>
          <img
            class="image_19"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng1ed66828e9d5c127e37c5af4013a8d1518ca2969004fc932ee200fc5bb5346e1.png"
          />
          <div class="text-wrapper_14 flex-col">
            <img
              class="label_43"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc0ebf2c7f3fed7820ee67777cc5dbc8ea038d2e92c6bf24482b132023261ad4d.png"
            />
          </div>
        </div>
        <div class="text-wrapper_79 flex-row">
          <span class="text_38">{{ $t('chooseIndustryScene') }}</span>
          <span class="text_39">{{ $t('aiCustomerSimulationTraining') }}</span>
          <span class="text_40">{{ $t('realTimeEmotionAndAbilityFeedback') }}</span>
          <span class="text_41">{{ $t('abilityModelAnalysisReport') }}</span>
          <span class="text_42">{{ $t('continuousOptimizationGrowth') }}</span>
        </div>
        <img
          class="image_113"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng96ff181bc1e5de4bb4cf7d5eec2b8fabfc1ae6455120a99b8656acd45b609b32.png"
        />
        <img
          class="image_114"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b9a480a2e07d7d29dd48a7797300da0dfd3a71495ddf2cb17aa5f8c8baff8dd.png"
        />
        <img
          class="image_115"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng96ff181bc1e5de4bb4cf7d5eec2b8fabfc1ae6455120a99b8656acd45b609b32.png"
        />
        <img
          class="image_116"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b9a480a2e07d7d29dd48a7797300da0dfd3a71495ddf2cb17aa5f8c8baff8dd.png"
        />
        <img
          class="image_117"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng96ff181bc1e5de4bb4cf7d5eec2b8fabfc1ae6455120a99b8656acd45b609b32.png"
        />
        <img
          class="image_118"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b9a480a2e07d7d29dd48a7797300da0dfd3a71495ddf2cb17aa5f8c8baff8dd.png"
        />
        <img
          class="image_119"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng96ff181bc1e5de4bb4cf7d5eec2b8fabfc1ae6455120a99b8656acd45b609b32.png"
        />
        <img
          class="image_120"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b9a480a2e07d7d29dd48a7797300da0dfd3a71495ddf2cb17aa5f8c8baff8dd.png"
        />
        <div class="text-wrapper_16 flex-col">
          <img
            class="image_121"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngdbb3c18848d1d2d6b9cad99e7166efd1143af2e41045ed8ff4dfb4b1b98c42a4.png"
          />
        </div>
        <div class="text-wrapper_17 flex-col">
          <img
            class="image_122"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng25687c3d0e283e91b2ce348a3bf4fb735afacef246dd05e7152b2efdbc2d0101.png"
          />
        </div>
        <div class="text-wrapper_18 flex-col">
          <img
            class="label_44"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng77dd43dbfee1dc4c6cc3fbbec9bba9e9ea7f18e7a1c8f4cd7a85f074aee380a9.png"
          />
        </div>
      </div>
      <span id="application-scenarios" class="text_46">{{ $t('applicationScenarios') }}</span>
      <div class="box_87 flex-row justify-between">
        <div class="box_30 flex-col">
          <div class="group_69 flex-row justify-between">
            <div class="image-wrapper_13 flex-col">
              <img
                class="label_45"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPngdd4c77f677b56c9826f38e21323147101bc7a949c5e3c72b47f66617ac67bec9.png"
              />
            </div>
            <span class="text_108">{{ $t('goldenSalesQuickening') }}</span>
          </div>
          <span class="text_109">{{ $t('goldenSalesQuickeningDesc') }}</span>
        </div>
        <div class="box_31 flex-col">
          <div class="section_41 flex-row justify-between">
            <div class="image-wrapper_14 flex-col">
              <img
                class="label_46"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng4cd50ca260dd87482d42c0ec22b610258aa5414c350f56ab908c37f50c7d1a73.png"
              />
            </div>
            <span class="text_110">{{ $t('excellentCustomerService') }}</span>
          </div>
          <span class="text_111">{{ $t('excellentCustomerServiceDesc') }}</span>
        </div>
        <div class="box_32 flex-col">
          <div class="box_88 flex-row justify-between">
            <div class="image-wrapper_15 flex-col">
              <img
                class="label_47"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng1cc0933befa4908ffe575f486f16675a803df54e52f5fd95449ad7cf219508e9.png"
              />
            </div>
            <span class="text_112">{{ $t('newEmployeeStandardization') }}</span>
          </div>
          <span class="text_113">{{ $t('newEmployeeStandardizationDesc') }}</span>
        </div>
      </div>
      <div class="box_89 flex-row justify-between">
        <div class="group_45 flex-col">
          <div class="block_22 flex-row justify-between">
            <div class="image-wrapper_16 flex-col">
              <img
                class="label_48"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng99d1debdd298dbfc20a3b3b4336dde6c7127ea5e8f1edb2cd83a166e54712243.png"
              />
            </div>
            <span class="text_114">{{ $t('productKnowledgeAndMarketingScriptPractice') }}</span>
          </div>
          <span class="text_115">{{ $t('productKnowledgeAndMarketingScriptPracticeDesc') }}</span>
        </div>
        <div class="group_46 flex-col justify-end">
          <div class="group_70 flex-row justify-between">
            <div class="image-wrapper_17 flex-col">
              <img
                class="label_49"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPnge9840aa2aee55f3b0fedfcefce96213f466d402dd86f8f4bcd1e84c76ac48c8b.png"
              />
            </div>
            <span class="text_116">{{ $t('highPotentialTalentAbilityAdvancement') }}</span>
          </div>
          <span class="paragraph_9">
            {{ $t('highPotentialTalentAbilityAdvancementDesc') }}
            <br />
          </span>
        </div>
        <div class="group_48 flex-col">
          <div class="section_42 flex-row justify-between">
            <div class="image-wrapper_18 flex-col">
              <img
                class="label_50"
                referrerpolicy="no-referrer"
                src="./assets/img/SketchPng54ade8170e818e02fde1fac02db31437930292cd84054775c237d165f6dacb39.png"
              />
            </div>
            <span class="text_117">{{ $t('moreIndustryCustomization') }}</span>
          </div>
          <span class="text_118">{{ $t('moreIndustryCustomizationDesc') }}</span>
        </div>
      </div>
      <div class="text-group_75 flex-col justify-between">
        <span id="trusted-platform" class="text_58">{{ $t('trustedEnterpriseAlTrainingPlatform') }}</span>
        <span class="text_119">{{ $t('buildEfficientTeamWithArkCoach') }}</span>
      </div>
      <div class="box_90 flex-row justify-between">
        <div class="image-wrapper_19 flex-col">
          <img
            class="image_67"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6e804c5659e9f896c39d80de17443e6b8790f05496f6993a5135d68d56e67707.png"
          />
        </div>
        <div class="image-wrapper_20 flex-col">
          <img
            class="image_68"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng208f23611beaf8ff03e76eeaca76a87583afe90e0b477ec41f3779bf5caebe27.png"
          />
        </div>
        <div class="image-wrapper_21 flex-col">
          <img
            class="label_17"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngaebdb4471f30d78e48067305ed602b8a9b0835f6145bcce2436094d0ee2b45a6.png"
          />
        </div>
        <div class="image-wrapper_22 flex-col">
          <img
            class="image_69"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng0848c6d806c581c8bbf03139dcd4266599514dfa4569f7dbec9ce9e7d6d34cf0.png"
          />
        </div>
        <div class="image-wrapper_23 flex-col">
          <img
            class="image_70"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng6b2e7a7c92f9c386416047f38f398bb0ccd019ef8551b50424e68f8d8f856d7a.png"
          />
        </div>
      </div>
      <div class="box_91 flex-row justify-between">
        <div class="block_6 flex-row">
          <div class="image-text_26 flex-row justify-between">
            <div class="text-group_76 flex-col justify-between">
              <span class="text_59">{{ $t('trainingCycleShortening') }}</span>
              <span class="text_60">{{ $t('newEmployeeOnboardingTimeAverageShortening') }}</span>
            </div>
            <img
              class="image_123"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngd2b773c65d428a5a34a488840131ed0f7f93e2908d682ac69edd637d59a41b87.png"
            />
          </div>
        </div>
        <div class="block_7 flex-row">
          <div class="image-text_27 flex-row justify-between">
            <div class="text-group_77 flex-col justify-between">
              <span class="text_61">{{ $t('trainingCostReduction') }}</span>
              <span class="text_62">{{ $t('trainingCostAverageReduction') }}</span>
            </div>
            <img
              class="image_124"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngeccfa8304f163a4468de272dbaae64a310ae525258847e425bddfe1ea60bcc3f.png"
            />
          </div>
        </div>
        <div class="block_8 flex-row">
          <div class="text-group_78 flex-col justify-between">
            <span class="text_63">{{ $t('businessConversionEnhancement') }}</span>
            <span class="text_64">{{ $t('businessConversionRateAverageIncrease') }}</span>
          </div>
          <img
            class="image_125"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb1f62fb0a4b25733d144e3ba22b1c16b54932beac2856e1da7c2cd12b8ed8b2d.png"
          />
        </div>
      </div>
      <div class="box_92 flex-row justify-between">
        <div class="section_24 flex-row">
          <div class="text-group_79 flex-col justify-between">
            <span class="text_96">{{ $t('preciseOrganizationAbilityOptimization') }}</span>
            <span class="text_97">
              {{ $t('arkCoachAfterUse') }}
              <br />
              {{ $t('keyAbilityBreakthrough90') }}
            </span>
          </div>
          <img
            class="image_126"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng833f2732ce0f0dcf0723f63f357df471b387dfb14125d93a7af6870e9fcf8fce.png"
          />
        </div>
        <div class="box_21 flex-row">
          <div class="text-group_80 flex-col justify-between">
            <span class="text_65">{{ $t('comprehensiveCustomerExperienceImprovement') }}</span>
            <span class="text_66">{{ $t('professionalAndStandardizedServiceDialogue') }}</span>
          </div>
          <img
            class="image_127"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng0fd2e0e313667b5a9f9256a64260aed746c8d99d64ca93d39cc69e6516e2ec8f.png"
          />
        </div>
        <div class="box_22 flex-row">
          <div class="text-group_81 flex-col justify-between">
            <span class="text_67">{{ $t('employeeContinuousGrowth') }}</span>
            <span class="text_68">{{ $t('employeeDiscoveryOfCognitiveBlindSpots') }}</span>
          </div>
          <img
            class="image_128"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng4525466793936f50253662e96361e237b02778b04f46df7ff66794244c163ade.png"
          />
        </div>
      </div>
      <div class="box_93 flex-row">
        <div class="text-wrapper_25">
          <span class="text_69">50</span>
          <span class="text_70">%</span>
        </div>
        <img
          class="image_33"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPnga23da089aa7b0ee25804b578d298ea39a8122cb4853313d3598d452a738c0a60.png"
        />
        <div class="text-wrapper_26">
          <span class="text_72">40</span>
          <span class="text_73">%</span>
        </div>
        <img
          class="image_34"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPnga23da089aa7b0ee25804b578d298ea39a8122cb4853313d3598d452a738c0a60.png"
        />
        <div class="text-wrapper_27">
          <span class="text_75">20</span>
          <span class="text_76">%+</span>
        </div>
        <img
          class="image_77"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPnga23da089aa7b0ee25804b578d298ea39a8122cb4853313d3598d452a738c0a60.png"
        />
        <div class="text-wrapper_48">
          <span class="text_120">90</span>
          <span class="text_121">%</span>
        </div>
      </div>
      <div class="text-wrapper_80 flex-row">
        <span class="text_71">{{ $t('comparedToTraditionalMethods') }}</span>
        <span class="text_74">{{ $t('trainingCostReduction') }}</span>
        <span class="text_77">{{ $t('salesConversionRateEnhancement') }}</span>
        <span class="text_122">{{ $t('keyAbilityEnhancementRate') }}</span>
      </div>
      <div id="contact-us" class="group_28 flex-col">
        <span class="text_81">{{ $t('readyToUpgradeYourTeam') }}</span>
        <div class="text-wrapper_81 flex-row">
          <span class="text_82">
            {{ $t('twoSteps') }}
            {{ $t('steps') }}
            {{ $t('aiIntelligentDialogueTraining') }}
            {{ $t('helpYourTeamEfficientGrowth') }}
          </span>
        </div>
        <div class="group_71 flex-row justify-between">
          <div class="text-wrapper_29 flex-col" @click="handleLogin"><span class="text_83">{{ $t('freeTrial') }} ARK Coach</span></div>
          <div class="text-wrapper_51 flex-col" @click="handleLogin"><span class="text_124">{{ $t('login') }}</span></div>
        </div>
      </div>
    </div>
    <!-- 新设计的底部区域 -->
    <div class="footer-section flex-col">
      <div class="footer-content flex-row justify-between">
        <!-- 联系方式卡片 -->
        <div class="footer-contact-cards flex-row">
          <div class="footer-card">
            <div class="footer-card-icon">📧</div>
            <div class="footer-card-title">{{ $t('businessCooperation') }}</div>
            <div class="footer-card-text">business@emotibot.com</div>
          </div>
          <div class="footer-card">
            <div class="footer-card-icon">🤝</div>
            <div class="footer-card-title">{{ $t('channelCooperation') }}</div>
            <div class="footer-card-text">partner@emotibot.com</div>
          </div>
          <div class="footer-card">
            <div class="footer-card-icon">👥</div>
            <div class="footer-card-title">{{ $t('joinUs') }}</div>
            <div class="footer-card-text">job@emotibot.com</div>
          </div>
          <div class="footer-card">
            <div class="footer-card-icon">💬</div>
            <div class="footer-card-title">{{ $t('technicalSupport') }}</div>
            <div class="footer-card-text">ecc@emotibot.com</div>
          </div>
        </div>
        <!-- 热线电话 -->
        <div class="footer-hotline">
          <div class="footer-hotline-label">{{ $t('hotline') }}</div>
          <div class="footer-hotline-number">400-831-9111</div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="footer-divider"></div>
      <!-- 版权信息 -->
      <div class="footer-copyright flex-row justify-between">
        <span class="footer-copyright-text">
          Copyright © 2022 北京通来复科技有限公司 All Rights Reserved
        </span>
        <span class="footer-icp">
          沪ICP备15045042号-4 | 沪公网备案31010402002611号
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentLang: 'zh-CN', // 先给默认值，避免this.$i18n未定义报错
      showLangDropdown: false
    };
  },
  created() {
    this.currentLang = this.$i18n.locale;
    // 添加点击外部关闭下拉框的事件监听
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
    '$i18n.locale'(val) {
      this.currentLang = val;
    }
  },
  methods: {
    toggleLangDropdown() {
      this.showLangDropdown = !this.showLangDropdown;
    },
    selectLang(lang) {
      this.currentLang = lang;
      this.$i18n.locale = lang;
      this.showLangDropdown = false;
      // 强制重新渲染以确保样式更新
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.lang-dropdown');
      if (dropdown && !dropdown.contains(event.target)) {
        this.showLangDropdown = false;
      }
    },
    changeLang(e) {
      this.$i18n.locale = e.target.value;
      this.currentLang = e.target.value;
    },
    handleLogin() {
      window.open('https://app.x-coach.co/', '_blank');
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'auto',
          block: 'start'
        });
      }
    }
  }
}
</script>
<style scoped lang="css" src="./assets/index.css" />